/*
  Cart drawer jeans upsell - arrow handling.

  Uses delegated listeners so it keeps working after the drawer's HTML is swapped
  in via AJAX. Prev/next scroll the row by ~80% of its width and hide themselves
  at the start/end (same "is-hidden" class "You may also like" uses).
*/
(function () {
  if (window.__cjuInit) return;
  window.__cjuInit = true;

  function sync(scroller) {
    var wrap = scroller.closest('.cart-jeans-upsell');
    if (!wrap) return;
    var prev = wrap.querySelector('.js-cju-prev');
    var next = wrap.querySelector('.js-cju-next');
    var max = scroller.scrollWidth - scroller.clientWidth;
    if (prev) prev.classList.toggle('is-hidden', scroller.scrollLeft <= 2);
    if (next) next.classList.toggle('is-hidden', max <= 2 || scroller.scrollLeft >= max - 2);
  }

  var queued = false;
  function syncAll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll('.js-cju-scroll').forEach(sync);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-cju-prev, .js-cju-next');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.cart-jeans-upsell');
    var scroller = wrap && wrap.querySelector('.js-cju-scroll');
    if (!scroller) return;
    var dir = btn.classList.contains('js-cju-next') ? 1 : -1;
    scroller.scrollBy({ left: dir * scroller.clientWidth * 0.8, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('js-cju-scroll')) {
      sync(e.target);
    }
  }, true);

  window.addEventListener('resize', syncAll);
  window.addEventListener('load', syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('cart-recommendations:update', syncAll);
  new MutationObserver(syncAll).observe(document.documentElement, { childList: true, subtree: true });
})();
